import { useState } from "react"
import { getOfertaDetById, postOfertaDet, patchOfertaDet } from "../../services/OfertasDetServices"
import { getArticuloById } from "../../services/ArticulosServices";
import { OfertasDetFormContext } from "./OfertasDetContext"
import { useNavigate} from 'react-router-dom';
//import { Color } from '../../routes/RoutesConstants'

export const OfertasDetFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const navigate = useNavigate();

    const getOfertaDetByIdData = async (id) => {
        let res = await getOfertaDetById(id)
        if (res) setReport(res)
        return res
    }

    const postOfertaDetData = async (body) => {
        const res = await postOfertaDet(body)
        if (res) navigate("/ofertasdet");
    }

    const patchOfertaDetData = async (id, body) => {
        
        const res = await patchOfertaDet(id, body);
        if (res) {
            // Verifica si `body.ofcad` está disponible y redirige a la nueva ruta
            if (res.data.ofcab_id) {
                navigate(`/ofertas/new/${res.data.ofcab_id}`);
            } else {
                
                navigate("/ofertas");
            }
        }
    };
    

    const getArticuloByIdData = async (id) => {
        try {
            let res = await getArticuloById(id);
            return res;
        } catch (error) {
            console.error("Error obteniendo artículo por ID:", error);
            return null;
        }
    };

    return <OfertasDetFormContext.Provider value={{
        report,
        getOfertaDetByIdData,
        postOfertaDetData,
        patchOfertaDetData,
        getArticuloByIdData,

    }} >
        {children}
    </OfertasDetFormContext.Provider>
}